const CONFIGURATION = {
    defaultTheme: 'dpasa-dark',
    authorizedDomains: ['kalk.ai'],
    apps: {
        dpasa: {
            enabled: true,
            url: 'https://3.kalk.ai',
        },
        mipasa: {
            enabled: false,
        },
        unbounded: {
            enabled: false,
        },
        papillon: {
            enabled: false,
        },
        crypto: {
            enabled: false,
        },
        soikie: {
            enabled: false,
        },
    },
    oidc: {
        github: false,
        google: false,
        ethereum: true,
    },
    sentry: {
        enabled: false,
    },
};
export default CONFIGURATION;
